module.exports = __webpack_public_path__ + "images/CallRecordings-d308b10f1febaceab0b613eabd871330.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/CallRecordings.png
// module id = T5sV
// module chunks = 0